export default __webpack_public_path__ + "static/media/chevron_right.28a45029.svg";